import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import AddonsDrawer from "components/drawer/AddonDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";
import React, { useState } from "react";
import { Dialog } from "@headlessui/react";

const AddonsTable = ({ roledata, hideDelete, hideEdit }) => {
  const { title, serviceId, handleModalOpen, handleUpdate, isSubmitting } =
    useToggleDrawer();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [allCities, setAllCities] = useState([]);

  const handleViewAllCities = (citiesString) => {
    const cityList = citiesString?.split(",").map((city) => city.trim()) || [];
    setAllCities(cityList);
    setIsModalOpen(true);
  };

  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <AddonsDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {roledata?.slice(0).map((data, index) => {
          const cityList =
            data.city_names?.split(",").map((c) => c.trim()) || [];
          const firstTwenty = cityList.slice(0, 20).join(", ");

          return (
            <TableRow key={data.id}>
              <TableCell className="text-center text-xs">{index + 1}</TableCell>

              <TableCell className="text-center text-xs">{data.name}</TableCell>

              <TableCell
                className="text-center text-xs whitespace-normal break-words"
                style={{ maxWidth: "150px" }}
              >
                {firstTwenty}
                {cityList.length > 20 && (
                  <button
                    className="block text-blue-600 mt-2 text-xs ml-auto"
                    onClick={() => handleViewAllCities(data.city_names)}
                  >
                    View All
                  </button>
                )}
              </TableCell>

              <TableCell className="text-center text-xs">
                {data.price}
              </TableCell>

              <TableCell>
                <div className="flex justify-center">
                  <EditDeleteButton
                    id={data.id}
                    isSubmitting={isSubmitting}
                    handleUpdate={handleUpdate}
                    handleModalOpen={handleModalOpen}
                    hideDelete={hideDelete}
                    hideEdit={hideEdit}
                  />
                </div>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>

      {/* Modal */}
      <Dialog
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        className="fixed inset-0 overflow-y-auto w-full"
        style={{ backgroundColor: "#00000033", zIndex: "5555555555" }}
      >
        <div className="flex items-center justify-center min-h-screen p-4">
          <Dialog.Panel className="bg-white rounded-lg p-6 max-w-3xl w-full shadow-lg">
            <Dialog.Title className="text-lg font-bold mb-2">
              All Cities
            </Dialog.Title>
            <ul
              className="text-sm overflow-y-scroll gap-2 grid grid-cols-2"
              style={{ height: "400px" }}
            >
              {allCities.map((city, index) => (
                <li
                  style={{
                    textOverflow: "ellipsis",
                    textWrap: "nowrap",
                    overflowX: "clip",
                  }}
                  key={index}
                >
                  {city},
                </li>
              ))}
            </ul>
            <button
              onClick={() => setIsModalOpen(false)}
              className="mt-4 px-4 py-2 text-green-500  hover:text-green-700"
            >
              Got it
            </button>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
};

export default AddonsTable;
